<template>
  <v-card :loading="busy">
    <v-card-title>
      {{ routine.name }}
      <v-spacer></v-spacer>
      <v-switch
          :input-value="routine.active"
          inset
          hide-details
          class="mt-0 pt-0"
          color="orange"
          :disabled="busy"
          @change="setActive"
      ></v-switch>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item @click="$emit('edit', routine)">
            <v-list-item-icon><v-icon>mdi-pencil</v-icon></v-list-item-icon>
            <v-list-item-title>Bearbeiten</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="routine.map_position" @click="clearPosition">
            <v-list-item-icon><v-icon>mdi-map-marker-remove</v-icon></v-list-item-icon>
            <v-list-item-title>Trigger von Karte entfernen</v-list-item-title>
          </v-list-item>
          <v-list-item @click="remove">
            <v-list-item-icon><v-icon>mdi-delete</v-icon></v-list-item-icon>
            <v-list-item-title>Löschen</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-card-title>

    <v-card-subtitle align="left">
      <v-icon small :color="routine.map_position ? 'amber' : ''">
        {{ routine.map_position ? 'mdi-gesture-tap-button' : 'mdi-gesture-tap-button' }}
      </v-icon>
      {{ routine.map_position
          ? 'Trigger auf der Karte — Platzieren über den Schnuffel-Tab'
          : 'Kein Karten-Trigger — platzieren über den Schnuffel-Tab („Geräte“-Dialog)' }}
    </v-card-subtitle>

    <v-card-text align="left">
      <v-chip
          v-for="(action, index) in routine.on_actions"
          :key="index"
          small
          class="mr-1 mb-1"
          :color="action.on ? 'orange' : ''"
      >
        {{ action.display_name || action.device_id }}
        <span v-if="!action.on">&nbsp;aus</span>
      </v-chip>
      <span v-if="routine.on_actions.length === 0" class="text--secondary">
        Keine Aktionen definiert
      </span>
    </v-card-text>
  </v-card>
</template>

<script>
import { smarthausApi } from '../../../services/smarthaus'

export default {
  name: 'RoutineCard',
  props: {
    routine: { type: Object, required: true },
  },
  data: () => ({
    busy: false,
  }),
  methods: {
    async run(promise) {
      this.busy = true
      try {
        const data = await promise
        this.$emit('changed', data && data.routine ? data.routine : null)
      } catch (e) {
        console.error('[RoutineCard]', e)
        this.$emit('changed', null)
      } finally {
        this.busy = false
      }
    },
    setActive(active) { return this.run(smarthausApi.routineActive(this.routine.id, !!active)) },
    clearPosition() { return this.run(smarthausApi.routineClearPosition(this.routine.id)) },
    remove() {
      if (!confirm(`Routine "${this.routine.name}" löschen?`)) return
      return this.run(smarthausApi.routineDelete(this.routine.id))
    },
  },
}
</script>
